import { render, staticRenderFns } from "./LuCensusReport.vue?vue&type=template&id=a64de9ea&"
import script from "./LuCensusReport.vue?vue&type=script&lang=js&"
export * from "./LuCensusReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports